/* AONSK V10.71 */
(() => {
  const root = document.querySelector('[data-yaupon-article][data-aonsk-cultural="true"]');
  if (!root) return;

  const body = root.querySelector('.yt-article-body');
  if (!body) return;

  // Place theme-hosted figures into deliberate editorial slots in the article body.
  root.querySelectorAll('template[data-aonsk-media-template]').forEach((template) => {
    const name = template.dataset.aonskMediaTemplate;
    const slot = body.querySelector(`[data-aonsk-media-slot="${CSS.escape(name)}"]`);
    if (!slot) return;
    const fragment = template.content.cloneNode(true);
    slot.replaceWith(fragment);
  });

  // Remove any empty media placeholders left by a partial import.
  body.querySelectorAll('.aonsk-media-slot:empty').forEach((slot) => slot.remove());

  // Tables remain readable on mobile without changing their semantic structure.
  body.querySelectorAll('table').forEach((table) => {
    if (table.parentElement && table.parentElement.classList.contains('scrollable-table')) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'scrollable-table aonsk-scrollable-table';
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });

  // Add accessible labels to evidence callouts when an editor omitted one.
  body.querySelectorAll('.aonsk-evidence-note').forEach((note) => {
    if (!note.hasAttribute('role')) note.setAttribute('role', 'note');
  });
})();
